"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBillResponseToJSON = exports.GetBillResponseFromJSONTyped = exports.GetBillResponseFromJSON = exports.instanceOfGetBillResponse = void 0;
var runtime_1 = require("../runtime");
var BillAddress_1 = require("./BillAddress");
var BillCampaign_1 = require("./BillCampaign");
var BillStatus_1 = require("./BillStatus");
var PaymentDetails_1 = require("./PaymentDetails");
/**
 * Check if a given object implements the GetBillResponse interface.
 */
function instanceOfGetBillResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetBillResponse = instanceOfGetBillResponse;
function GetBillResponseFromJSON(json) {
    return GetBillResponseFromJSONTyped(json, false);
}
exports.GetBillResponseFromJSON = GetBillResponseFromJSON;
function GetBillResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, BillStatus_1.BillStatusFromJSON)(json['status']),
        'paymentDetails': !(0, runtime_1.exists)(json, 'payment_details') ? undefined : (0, PaymentDetails_1.PaymentDetailsFromJSON)(json['payment_details']),
        'issuedAt': !(0, runtime_1.exists)(json, 'issued_at') ? undefined : (new Date(json['issued_at'])),
        'totalInMicros': !(0, runtime_1.exists)(json, 'total_in_micros') ? undefined : json['total_in_micros'],
        'totalTaxInMicros': !(0, runtime_1.exists)(json, 'total_tax_in_micros') ? undefined : json['total_tax_in_micros'],
        'taxDescription': !(0, runtime_1.exists)(json, 'tax_description') ? undefined : json['tax_description'],
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
        'receiptNumber': !(0, runtime_1.exists)(json, 'receipt_number') ? undefined : json['receipt_number'],
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'campaigns': !(0, runtime_1.exists)(json, 'campaigns') ? undefined : (json['campaigns'].map(BillCampaign_1.BillCampaignFromJSON)),
        'billTo': !(0, runtime_1.exists)(json, 'bill_to') ? undefined : (0, BillAddress_1.BillAddressFromJSON)(json['bill_to']),
        'billFrom': !(0, runtime_1.exists)(json, 'bill_from') ? undefined : (0, BillAddress_1.BillAddressFromJSON)(json['bill_from']),
        'vatId': !(0, runtime_1.exists)(json, 'vat_id') ? undefined : json['vat_id'],
    };
}
exports.GetBillResponseFromJSONTyped = GetBillResponseFromJSONTyped;
function GetBillResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ad_account_id': value.adAccountId,
        'status': (0, BillStatus_1.BillStatusToJSON)(value.status),
        'payment_details': (0, PaymentDetails_1.PaymentDetailsToJSON)(value.paymentDetails),
        'issued_at': value.issuedAt === undefined ? undefined : (value.issuedAt.toISOString()),
        'total_in_micros': value.totalInMicros,
        'total_tax_in_micros': value.totalTaxInMicros,
        'tax_description': value.taxDescription,
        'currency_code': value.currencyCode,
        'receipt_number': value.receiptNumber,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(BillCampaign_1.BillCampaignToJSON)),
        'bill_to': (0, BillAddress_1.BillAddressToJSON)(value.billTo),
        'bill_from': (0, BillAddress_1.BillAddressToJSON)(value.billFrom),
        'vat_id': value.vatId,
    };
}
exports.GetBillResponseToJSON = GetBillResponseToJSON;
